'use client'


const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex flex-col md:flex-row items-center justify-center bg-gray-50 px-4 py-8">
      {/* Left: Illustration */}
      <div className="flex flex-col items-center md:items-end md:w-1/2">
        <img src="/images/404.png" alt="404 Illustration" className="w-full h-auto object-contain max-w-lg" />
      </div>


      <div className="mt-8 md:mt-0 md:ml-16 flex-1 flex flex-col items-center justify-center md:items-start text-center md:text-left ">
        <h1 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4">404 - Không tìm thấy trang</h1>
        <p className="text-lg md:text-xl text-gray-600 mb-6 text-center w-fit">
          Rất tiếc, trang bạn đang tìm kiếm không tồn tại hoặc đã bị di dời.
        </p>
        <a
          href="/"
          className="inline-block px-6 py-3 bg-green-600 text-white font-semibold rounded-full shadow hover:bg-green-700 transition"
        >
          Quay lại trang chủ
        </a>
      </div>
    </div>
  )
}

export default NotFoundPage